module.exports = __webpack_public_path__ + "media/images/illustrations/flat_clip_uploading-fb11bdb811da67e4f47a32b742e8c641.png";